<template>
  <div class="noprint">
    <b-card
      v-if="!activatePayment && isLoaded"
      no-body
      border-variant="msstream"
    >
      <b-card-header
        header-bg-variant="msstream"
        header-text-variant="white"
        class="text-center"
      >
        <h5 class="m-0">
          <font-awesome-icon icon="shopping-cart"></font-awesome-icon
          >&nbsp;&nbsp;{{ $ml.get("producttitle") }}
        </h5>
      </b-card-header>
      <b-card-body>
        <!-- MB Month -->
        <b-row class="align-items-center">
          <b-col md="4" sm="4" cols="12">
            <!-- DATA -->
            <b-row class="justify-content-center marginaltop mb-4">
              <b-col cols="auto" style="text-align:center;">
                <h4>
                  {{ $ml.get("pldatadelivered") }}
                  <strong
                    v-bind:class="{
                      'text-red': currentData > maxData,
                      'text-blue': currentData <= maxData,
                    }"
                    >{{ currentDataTB.toFixed(2) }} {{ $ml.get("TBunit") }} 
                  </strong>
                  <!--
                  <strong
                    v-bind:class="{
                      'text-green': maxData > baseData,
                      'text-blue': maxData <= baseData,
                    }"
                    >{{ maxData }} {{ $ml.get("GBunit") }}</strong
                  >
                  
                  &nbsp;
                  <b-button
                    v-if="!isAutoAdjust"
                    variant="msstreamblue"
                    @click="increaseData"
                    >+</b-button
                  >
                  
                  &nbsp;
                  <b-button
                    v-if="
                      !isAutoAdjust &&
                      maxData > baseData &&
                      maxData > multiplierData
                    "
                    variant="quanteec"
                    @click="decreaseAll"
                    >-</b-button
                  >
                  -->
                </h4>
                <div><small>{{ $ml.get("TBstarted") }}</small></div>

              </b-col>

            </b-row>

            <b-row v-if="$auth.getMyUser().roles.indexOf('admin') > -1" class="justify-content-center marginaltop mb-4">
              <b-col cols="auto">
                <h4>
                  {{ $ml.get("lastdatadelivered") }}
                  <strong
                    class="text-blue"
                    >{{ lastDataTB.toFixed(2) }} {{ $ml.get("TBunit") }} 
                  </strong>
                </h4>
              </b-col>
            </b-row>

            <!--
            <b-row class="justify-content-center">
              <b-col class="col-9">
                <b-progress :max="maxData" height="2rem">
                  <b-progress-bar
                    :value="currentData"
                    animated
                    :variant="
                      currentData > maxData ? 'quanteecdanger' : 'quanteec'
                    "
                  >
                    <!--Progress: <strong>{{ Math.round(dataMonth / 10000) / 100}} / {{ 10 }} TB</strong>-->
                  <!--</b-progress-bar>
                </b-progress>
              </b-col>
            </b-row>
            
            <b-row
              class="justify-content-center marginaltopsm"
              v-if="isAutoAdjust && isContractSigned"
            >
              <b-col cols="auto">
                <small
                  >{{ $ml.get("nextlevel") }}: +
                  <strong class="text-blue">{{ priceData }} €</strong>
                  {{ $ml.get("restant") }}
                  <strong class="text-blue"
                    >{{ maxData - currentData }} {{ $ml.get("GBunit") }}</strong
                  >.</small
                >
              </b-col>
            </b-row>
            
            <b-row
              class="justify-content-center marginaltopsm"
              v-if="isAutoAdjust && !isContractSigned"
            >
              <b-col cols="auto">
                <h6 style="color: #ba0000">
                  <font-awesome-icon
                    :icon="['fas', 'exclamation-triangle']"
                    size="sm"
                  />
                  {{ $ml.get("only") }} {{ maxData - currentData }}
                  {{ $ml.get("GBunit") }} {{ $ml.get("leftfree") }}
                </h6>
              </b-col>
            </b-row>
            -->
          </b-col>

          <b-col
            v-if="isAutoAdjust && isContractSigned"
            md="4"
            sm="4"
            cols="12"
          >
            <b-row class="align-item-center">
              <b-col style="text-align: center">
                <h4>
                  {{ $ml.get("currentprice") }}
                  <span
                    ><strong class="text-green"
                      >{{ newPrice_computed }} € </strong
                    ></span>
                </h4>
                <small v-if="isRIB">
                  {{ $ml.get("chargedon5") }}
                </small>
              </b-col>
            </b-row>
            <b-row v-if="$auth.getMyUser().roles.indexOf('admin') > -1" class="align-item-center marginaltop">
              <b-col style="text-align: center">
                <h4>
                  {{ $ml.get("lastprice") }}
                  <span
                    ><strong class="text-green"
                      >{{ lastPrice }} € </strong
                    ></span>
                </h4>
               
              </b-col>
            </b-row>
          </b-col>

          <b-col
            v-if="isAutoAdjust && isContractSigned"
            md="4"
            sm="4"
            cols="12"
          >
            <b-row v-if="isRIB && !clientViewObject.cards" class="align-item-center marginal">
              <b-col style="text-align: center">
                <small>
                  {{ $ml.get("modifybankdetails") }}
                  <a href="mailto:contact@quanteec.com">contact@quanteec.com</a>
                </small>
              </b-col>
            </b-row>
            <b-row v-if="isRIB && clientViewObject.cards" class="align-item-center marginal">
              <b-col style="text-align: center">
                <b-button variant="msstreamblue" @click="getSession">
                  <font-awesome-icon :icon="['fas', 'cog']" size="sm" />
                  <font-awesome-icon
                    :icon="['fas', 'credit-card']"
                    size="sm"
                    transform="shrink-6"
                  />
                  &nbsp;{{ $ml.get("billingpanel") }}
                </b-button>
              </b-col>
            </b-row>
            <b-row
              v-if="!isRIB && clientViewObject.cards"
              class="marginaltop justify-content-center"
            >
              <b-col cols="auto">
                <b-button variant="msstreamblue" @click="checkoutPayment"
                  ><font-awesome-icon
                    :icon="['fas', 'credit-card']"
                    size="sm"
                  />
                  {{ $ml.get("enterpaymentdetail") }}</b-button
                >
              </b-col>
            </b-row>
            <b-form v-if="!isRIB && !clientViewObject.cards" @submit.prevent="postRIB()">
              <b-form-group :label="$ml.get('rib')">
                <b-form-file
                  v-model="file"
                  :state="Boolean(file)"
                  required
                  :placeholder="$ml.get('chooseRIB')"
                ></b-form-file>
              </b-form-group>
              <b-row class="justify-content-center">
                <b-col md="auto">
                  <b-button variant="msstreamblue" type="submit">{{
                    $ml.get("uploadbankdet")
                  }}</b-button>
                </b-col>
              </b-row>
            </b-form>
          </b-col>

          <b-col
            v-if="isAutoAdjust && !isContractSigned"
            md="4"
            sm="4"
            cols="12"
          >
            <b-row class="justify-content-center align-item-center">
              <b-col style="text-align: center">
                <h4>
                  {{ $ml.get("currentprice") }}
                  <strong><span>{{ newPrice_computed }}€</span></strong>
                </h4>
                <div v-if="!demoOver" class="text-green">{{ $ml.get("free") }} </div>
              </b-col>
            </b-row>
          </b-col>

          <b-col
            v-if="isAutoAdjust && !isContractSigned"
            md="4"
            sm="4"
            cols="12"
            style="text-align: center"
          >
            <b-form @submit.prevent="validateContract()" class="marginaltop">
              <a :href="($ml.current === 'FR') ? 'https://quanteec.com/cgu/CGU_Quanteec_FR.pdf': 'https://quanteec.com/cgu/QUANTEEC_T+C_EN.pdf'" target="_blank">
                <b-row class="justify-content-center align-items-center">
                  <b-col cols="3" style="padding-left: 0px; padding-right: 0px;">
                      <b-img
                      :src="require('@/assets/pdf.png')"
                      fluid
                      ></b-img>
                  </b-col>
                  <b-col cols="auto" style="padding-left: 0px; padding-right: 0px;">
                      {{$ml.get('termsofservice')}}
                  </b-col>                      
                </b-row>
              </a>
              <b-form-group>
              <b-form-checkbox
              style="line-height: 1.5 !important;"
                  id="checkbox-1"
                  v-model="cguAccepted"
                  name="checkbox-cgu"
                  required
                  >
                  {{$ml.get('accepttermsofservice')}}
                  </b-form-checkbox>
              </b-form-group>
              <b-row class="justify-content-center">
                  <b-col cols="auto">
                      <b-button type="submit" variant="msstreamblue" :disabled="!cguAccepted">{{$ml.get('acceptcontract')}}</b-button>
                  </b-col>
              </b-row>
            </b-form>

            
            
            
          </b-col>
        </b-row>

        <b-row v-if="paymentdetails" class="justify-content-center">
          <b-col cols="12">
            <b-form
              @submit.prevent="
                validateContract();
                postRIB();
              "
              class="marginaltop"
            >
              <b-row class="align-items-center justify-content-center">
                <b-col cols="1">
                  <b-form-checkbox
                    style="line-height: 1.5 !important"
                    id="checkbox-1"
                    v-model="cguAccepted"
                    name="checkbox-cgu"
                    required
                    class="col-4"
                  >
                  </b-form-checkbox>
                </b-col>
                <b-col md="3" cols="6" style="text-align: justify">
                  <a :href="($ml.current === 'FR') ? 'https://quanteec.com/cgu/CGUV_Quanteec_FR.pdf': 'https://quanteec.com/cgu/QUANTEEC_T+C_EN.pdf'" target="_blank">
                    {{ $ml.get("accepttermsofservice") }}
                  </a>
                </b-col>
                <b-col lg="1" xs="2" cols="3">
                  <a :href="($ml.current === 'FR') ? 'https://quanteec.com/cgu/CGUV_Quanteec_FR.pdf': 'https://quanteec.com/cgu/QUANTEEC_T+C_EN.pdf'" target="_blank">
                    <b-img :src="require('@/assets/pdf.png')" fluid></b-img>
                  </a>
                </b-col>
              </b-row>
              <b-row class="marginal justify-content-center">
                <b-form-group :label="$ml.get('rib')">
                  <b-form-file
                    v-model="file"
                    :state="Boolean(file)"
                    required
                    :placeholder="$ml.get('chooseRIB')"
                  ></b-form-file>
                </b-form-group>
              </b-row>
              <b-row class="justify-content-around">
                <b-col cols="auto">
                  <b-button
                    type="submit"
                    variant="green"
                    :disabled="!cguAccepted"
                    >Ok</b-button
                  >
                </b-col>
                <b-col cols="auto">
                  <b-button
                    type="submit"
                    variant="mswarning"
                    @click="paymentdetails = false"
                    >{{ $ml.get("cancel") }}</b-button
                  >
                </b-col>
              </b-row>
            </b-form>
          </b-col>
        </b-row>

        <!--
        <b-row
          v-if="isAutoAdjust && isContractSigned && !showpreviousbilling"
          class="justify-content-center"
        >
          <!--<b-col cols="auto">
                    <b-button variant="msstreamblue" @click="showpreviousbilling = true">
                        {{$ml.get('previousbillings')}}
                    </b-button>
                </b-col>
          <b-col cols="auto">
            <b-button variant="msstreamblue" @click="getSession">
              <font-awesome-icon :icon="['fas', 'cog']" size="sm" />
              <font-awesome-icon
                :icon="['fas', 'credit-card']"
                size="sm"
                transform="shrink-6"
              />
              &nbsp;{{ $ml.get("billingpanel") }}
            </b-button>
          </b-col>
          <b-col cols="auto">
            <b-button
              variant="msstreamblue"
              v-if="!showpreviousbilling"
              @click="showpreviousbilling = true"
            >
              <font-awesome-icon :icon="['fas', 'history']" size="sm" />
              &nbsp;{{ $ml.get("consumptionhistory") }}
            </b-button>
          </b-col>
          <b-col cols="auto">
            <b-button
              variant="msstreamblue"
              v-if="showpreviousbilling"
              @click="showpreviousbilling = false"
            >
              {{ $ml.get("hidebillings") }}
            </b-button>
          </b-col>
        </b-row>
        
        <b-row
          v-if="isAutoAdjust && isContractSigned && showpreviousbilling"
          class="marginaltop"
        >
          <b-table :fields="billingfields" :items="billingitems">
            <template #cell(date)="data">
              {{ new Date(data.item.createdAt).getMonth() + 1 }} / {{ new Date(data.item.createdAt).getFullYear() }}
            </template>

            <template #cell(data)="data">
              {{ data.item.totalData }} {{ $ml.get("GBunit") }}
            </template>
          </b-table>

        </b-row>
        -->

        <div style="margin:2rem 4rem; border-top:1px solid #2a5d77"></div>
        
        <b-row class="justify-content-center" style="padding: 1rem; margin:2rem">
          <b-col cols="auto">
            <b-button style="margin-right:1rem" variant="msstreamblue" @click="showEstimator = !showEstimator">
              {{$ml.get('priceestcalc')}}
              <b-icon v-if="!showEstimator" icon="plus-circle"></b-icon>
              <b-icon v-else icon="dash-circle"></b-icon>
            </b-button>
            <b-button v-if="clientView === 'digiteka'" style="margin-left:1rem" variant="white" cols="4" @click="($ml.current === 'EN') ? downloadDocuments('QUANTEEC_Pricing_list_01_23_DIGITEKA.pdf') : downloadDocuments('QUANTEEC_Listing_Prix_01_23_DIGITEKA.pdf')" >
                <b-img
                :src="require('@/assets/pdf.png')"
                fluid
                style="max-height:3rem"
                ></b-img>
                {{$ml.get('pricinglist')}}
            </b-button>
            <b-button v-if="clientView === 'sportall'" style="margin-left:1rem" variant="white" cols="4" @click="($ml.current === 'EN') ? downloadDocuments('QUANTEEC_Pricing_list_01_23_SPORTALL.pdf') : downloadDocuments('QUANTEEC_Listing_Prix_01_23_SPORTALL.pdf')" >
                <b-img
                :src="require('@/assets/pdf.png')"
                fluid
                style="max-height:3rem"
                ></b-img>
                {{$ml.get('pricinglist')}}
            </b-button>

            <a v-if="clientView !== 'digiteka' && clientView !== 'sportall'" style="margin-left:1rem" variant="white" cols="4" :href="($ml.current === 'FR') ? pdfListPriceFR : pdfListPriceEN" donwload="download" target="_blank">
                <b-img
                :src="require('@/assets/pdf.png')"
                fluid
                style="max-height:3rem"
                ></b-img>
                {{$ml.get('pricinglist')}}
            </a>                      
          </b-col>
        </b-row>
        <b-row v-if="showEstimator" class="justify-content-center align-items-center">
          <b-col cols="auto" class="m-2">
            <label style="margin-bottom:0px" for="TBnumber">{{$ml.get('enternbrTB')}}</label>
          </b-col>
          <b-col cols="auto" class="m-2">
            <b-form-input id="TBnumber" v-model="TBnumber" type="number"></b-form-input>
          </b-col>
          <b-button variant="invisible" v-if="clientView==='digiteka'" @click="priceEstimationDigi"></b-button>
          <b-button variant="invisible" v-else-if="clientView==='sportall'" @click="priceEstimationSportall"></b-button>
          <b-button variant="invisible" v-else @click="priceEstimation"></b-button>
          <b-col cols="auto" class="m-2">
            {{$ml.get('price')}} <strong style="color:#14BF98"> {{priceTotal}} </strong>€
          </b-col>

          <b-col v-if="clientView === 'digiteka'" cols="auto" class="m-2 mr-5 ml-5">
            <b-row class="justify-content-center mb-2">
              <label for="range-1">{{$ml.get('priceperTB')}} <strong style="color:#2F90B0">{{ pricePerTB }} </strong>€</label>
            </b-row>
            <datalist id="tickmarks2">
              <option value="1.000" label="1.000€"></option>
              <option value="1.175" label="1.175€"></option>
              <option value="1.350" label="1.350€"></option>
            </datalist>
            <input style="width:300px" id="range-1" disabled v-model="pricePerTB" type="range" min="1" max="1.350" step="0.01" list="tickmarks" />
            <datalist id="tickmarks">
              <option value="1.000" label="> 1200TB"></option>
              <option value="1.175" label="975TB"></option>
              <option value="1.350" label="< 750TB"></option>
            </datalist>
          </b-col>

          <b-col v-else-if="clientView === 'sportall'" cols="auto" class="m-2 mr-5 ml-5">
            <b-row class="justify-content-center mb-2">
              <label for="range-1">{{$ml.get('priceperTB')}} <strong style="color:#2F90B0">{{ pricePerTB }} </strong>€</label>
            </b-row>
            <datalist id="tickmarks2">
              <option value="1.000" label="1€"></option>
              <option value="2.000" label="2€"></option>
              <option value="3.000" label="3€"></option>
              <option value="4.000" label="4€"></option>
            </datalist>
            <input style="width:300px" id="range-1" disabled v-model="pricePerTB" type="range" min="1" max="4" step="0.01" list="tickmarks" />
            <datalist id="tickmarks">
              <option value="1.000" label="> 1600TB"></option>
              <option value="2.000" label="400TB"></option>
              <option value="3.000" label="200TB"></option>
              <option value="4.000" label="<100TB"></option>
            </datalist>
          </b-col>

          <b-col v-else cols="auto" class="m-2 mr-5 ml-5">
            <b-row class="justify-content-center mb-2">
              <label for="range-1">{{$ml.get('priceperTB')}} <strong style="color:#2F90B0">{{ pricePerTB }} </strong>€</label>
            </b-row>
            <datalist id="tickmarks2">
              <option value="1.000" label="1€"></option>
              <option value="2.000" label="2€"></option>
              <option value="3.000" label="3€"></option>
              <option value="4.000" label="4€"></option>
              <option value="5.000" label="5€"></option>
            </datalist>
            <input style="width:300px" id="range-1" disabled v-model="pricePerTB" type="range" min="1" max="5" step="0.01" list="tickmarks" />
            <datalist id="tickmarks">
              <option value="1.000" label="> 1600TB"></option>
              <option value="2.000" label="400TB"></option>
              <option value="3.000" label="200TB"></option>
              <option value="4.000" label="100TB"></option>
              <option value="5.000" label="< 50TB"></option>
            </datalist>
          </b-col>
          
        </b-row>
        
      </b-card-body>
    </b-card>

    <b-card v-if="activatePayment" no-body border-variant="msstream">
      <b-card-header
        header-bg-variant="msstream"
        header-text-variant="white"
        class="text-center"
      >
        <h5 class="m-0">
          <font-awesome-icon icon="shopping-cart"></font-awesome-icon
          >&nbsp;PAYMENT METHOD
        </h5>
      </b-card-header>
      <b-card-body>
        <Payment :value="paymentValue"></Payment>
      </b-card-body>
    </b-card>

    <b-modal ref="confirmValidate" hide-footer hide-header>
      <div class="d-block text-center">
        <h4>Validate the new price: {{ newPrice_computed }} €/month</h4>
      </div>
      <p>This operation will definitely modify your offer.</p>
      <b-row class="justify-content-around">
        <b-btn
          class="col-md-3 col-5"
          variant="green"
          block
          @click="
            validatePrice();
            hideModal('confirmValidate');
          "
          >Yes, validate</b-btn
        >
        <b-btn
          class="col-md-3 col-5"
          variant="mswarning"
          block
          @click="hideModal('confirmValidate')"
          >Cancel</b-btn
        >
      </b-row>
    </b-modal>
    <b-modal ref="confirmAutoAdjust" hide-footer hide-header>
      <div class="d-block text-center">
        <h4>Auto adjust the price according to the capacities used</h4>
      </div>
      <p>
        The price at the end of the month may vary according to the ressources
        used.
      </p>
      <b-row class="justify-content-around">
        <b-btn
          class="col-md-3 col-5"
          variant="green"
          block
          @click="
            setAutoAdjust();
            hideModal('confirmAutoAdjust');
          "
          >Yes, validate</b-btn
        >

        <b-btn
          class="col-md-3 col-5"
          variant="mswarning"
          block
          @click="hideModal('confirmAutoAdjust')"
          >Cancel</b-btn
        >
      </b-row>
    </b-modal>

    <b-modal ref="ContractAccepted" hide-footer hide-header>
      <div class="d-block text-center">
        <h4 style="border-bottom: 1px solid #2a5d77; padding: 10px">
          {{ $ml.get("contractaccepted") }}
        </h4>
      </div>
      <p>
        {{ $ml.get("welcome") }}
      </p>
      <p>
        {{ $ml.get("uploadRIB") }}
        <a href="mailto:contact@quanteec.com">contact@quanteec.com</a>
      </p>
      <b-row class="justify-content-center">
        <b-btn
          class="col-md-3 col-5"
          variant="msstreamblue"
          block
          @click="hideModal('ContractAccepted')"
          >Ok</b-btn
        >
      </b-row>
    </b-modal>

    <b-modal ref="ErrorContract" hide-footer hide-header>
      <div class="d-block text-center">
        <h4 style="border-bottom: 1px solid #2a5d77; padding: 10px">
          {{ $ml.get("Error") }}
        </h4>
      </div>
      <p>
        {{ $ml.get("errorcontract") }}
        <a href="mailto:contact@quanteec.com">contact@quanteec.com</a>
      </p>
      <b-row class="justify-content-center">
        <b-btn
          class="col-md-3 col-5"
          variant="msstreamblue"
          block
          @click="hideModal('ErrorContract')"
          >Ok</b-btn
        >
      </b-row>
    </b-modal>

    <b-modal ref="RIBSuccess" hide-footer hide-header>
      <div class="d-block text-center">
        <h4 style="border-bottom: 1px solid #2a5d77; padding: 10px">
          {{ $ml.get("bankreceived") }}
        </h4>
      </div>
      <b-row class="justify-content-center">
        <b-btn
          class="col-md-3 col-5"
          variant="msstreamblue"
          block
          @click="hideModal('RIBSuccess')"
          >Ok</b-btn
        >
      </b-row>
    </b-modal>

    <b-modal ref="RIBError" hide-footer hide-header>
      <div class="d-block text-center">
        <h4 style="border-bottom: 1px solid #2a5d77; padding: 10px">
          {{ $ml.get("Error") }}
        </h4>
      </div>
      <p>
        {{ $ml.get("errorcontract") }}
        <a href="mailto:contact@quanteec.com">contact@quanteec.com</a>
      </p>
      <b-row class="justify-content-center">
        <b-btn
          class="col-md-3 col-5"
          variant="msstreamblue"
          block
          @click="hideModal('RIBError')"
          >Ok</b-btn
        >
      </b-row>
    </b-modal>
  </div>
</template>

<script>
import { saveAs } from "file-saver";
import Payment from "@/components/Payment";
import UserService from "@/services/user.service";
import ClientService from "@/services/client.service";
import DocumentService from "@/services/document.service";
import CDNService from "@/services/cdn.service";
let cdnService = new CDNService();
import PaymentService from "@/services/payment.service";
let paymentService = new PaymentService();
import AnalyticsService from "@/services/analytics.service";
var analyticsService = new AnalyticsService();

var userService = new UserService();
var clientService = new ClientService();
var documentService = new DocumentService();
var myDateBegin = new Date();
export default {
  name: "PriceAnalytics",
  data: function () {
    return {
      clientView:
        this.$auth.getMyUser().roles.indexOf("admin") > -1
          ? this.$auth.getMyClientView() || this.$auth.getMyUser().client
          : this.$auth.getMyUser().client,
      clientViewObject: this.$auth.getMyUser().roles.indexOf("admin") > -1
          ? this.$auth.getMyClientViewObject() || this.$auth.getMyUser().client_infos[0]
          : this.$auth.getMyUser().client_infos[0],
      key: "",
      dateEnd: new Date(),
      dateBegin: new Date(
        myDateBegin.getFullYear(),
        myDateBegin.getMonth(),
        1,
        0,
        0,
        0
      ),
      dateBeginLastMonth: new Date(
        myDateBegin.getFullYear(),
        myDateBegin.getMonth() - 1,
        1,
        0,
        0,
        0
      ),
      dateEndLastMonth: new Date(
        myDateBegin.getFullYear(),
        myDateBegin.getMonth(),
        1,
        0,
        0,
        0
      ),
      interval: "1d",
      filter: "*",
      totalViewingTime: 0,
      totalViews: 0,

      TBnumber: '1',
      showEstimator: false,
      pricePerTB: '5',
      priceTotal: '5',
      estPrice: '1',
      currentPrice: 10,
      multiplierPrice: 10,
      partialMultiplierPrice: 10,
      basePrice: 10,
      basePrice2: 0,

      lastData: 0,
      lastDataTB: 0,
      lastPrice: 0,

      currentData: 0,
      currentDataTB: 0,
      currentPricePerTB: 5,
      currentPriceTotal: 0,

      multiplierData: 1000,
      baseData: 1000,
      maxData: 0,
      priceData: 10,

      isAutoAdjust: true,
      paymentValue: 0,
      activatePayment: false,

      clientType: "plugin",
      isLoaded: false,
      forLater: false,

      isRIB: false,
      isContractReady: false,
      isContractSigned: false,
      typeOfContract: "views",
      cguAccepted: false,
      file: null,
      paymentdetails: false,
      showpreviousbilling: false,
      pdfListPriceEN: require('@/assets/QUANTEEC_Pricing_List_01_23.pdf'),
      pdfListPriceFR: require('@/assets/QUANTEEC_Listing_Prix_01_23.pdf'),
      billingfields: [
        {
          key: "date",
          label: "Month/Years",
        },
        {
          key: "data",
          label: "Data delivered",
        }
      ],
      billingitems: null,
    };
  },
  components: {
    Payment,
  },
  mounted() {
    this.key = this.clientView;
    this.getDataMonth();
    this.loadNewClientUuid();
    this.loadData().then(() => {
      this.loadData_LastMonth();
    }).catch(err => {
      this.loadData_LastMonth();
    })
    
    this.getBills();
  },
  computed: {
    dataMonth_computed() {
      return Math.round(this.dataMonth / 10000) / 100 + " TB";
    },
    newPrice_computed() {
      let price;
      if (this.clientView === 'digiteka') {
        price = this.computeNewPriceDigi(this.currentDataTB);
      }
      else 
        if (this.clientView === 'sportall') {
        price = this.computeNewPriceSportall(this.currentDataTB);
        }
        else {
          price = this.computeNewPrice(this.currentDataTB);
        }
      return price;
    },
    meanViewingTime() {
      if (this.totalViews > 0) {
        let value = Math.round(this.totalViewingTime / this.totalViews);
        let result = "";
        result += value + " s";
        return result;
      } else {
        return "0 s";
      }
    },
    priceEstimation() {
      if (this.TBnumber < 50) {
        this.pricePerTB = 5;
      }
      else
        if (this.TBnumber < 100) {
          this.pricePerTB = 6 - (this.TBnumber/50);
        }
        else
          if (this.TBnumber < 200) {
            this.pricePerTB = 5 - (this.TBnumber/100);
          }
          else
            if (this.TBnumber < 400) {
              this.pricePerTB = 4 - (this.TBnumber/200);
            }
            else
              if (this.TBnumber < 800) {
                this.pricePerTB = 5/2 - (this.TBnumber/800);
              }
              else
                if (this.TBnumber < 1600) {
                  this.pricePerTB = 2 - (this.TBnumber/1600);
                }
                else
                  if (this.TBnumber >= 1600) {
                    this.pricePerTB = 1;
                  }
                  
      this.priceTotal = Math.ceil(this.TBnumber) * this.pricePerTB;

      this.pricePerTB = this.pricePerTB.toFixed(3); 
      this.priceTotal = this.priceTotal.toFixed(3); 
    },
    priceEstimationDigi() {
      if (this.TBnumber < 750) {
        this.pricePerTB = 1.35;
      }
      else
        if (this.TBnumber < 1200) {
          this.pricePerTB = 29/15 - (7*this.TBnumber/9000);
        }
        else
          if (this.TBnumber >= 1200) {
            this.pricePerTB = 1;
          }
                  
      this.priceTotal = Math.ceil(this.TBnumber) * this.pricePerTB;

      this.pricePerTB = this.pricePerTB.toFixed(3); 
      this.priceTotal = this.priceTotal.toFixed(3); 
    },
    priceEstimationSportall() {
      if (this.TBnumber < 100) {
        this.pricePerTB = 4;
      }
        else
          if (this.TBnumber < 200) {
            this.pricePerTB = 5 - (this.TBnumber/100);
          }
          else
            if (this.TBnumber < 400) {
              this.pricePerTB = 4 - (this.TBnumber/200);
            }
            else
              if (this.TBnumber < 800) {
                this.pricePerTB = 5/2 - (this.TBnumber/800);
              }
              else
                if (this.TBnumber < 1600) {
                  this.pricePerTB = 2 - (this.TBnumber/1600);
                }
                else
                  if (this.TBnumber >= 1600) {
                    this.pricePerTB = 1;
                  }
                  
      this.priceTotal = Math.ceil(this.TBnumber) * this.pricePerTB;

      this.pricePerTB = this.pricePerTB.toFixed(3); 
      this.priceTotal = this.priceTotal.toFixed(3); 
    },
  },
  methods: {
    getSession() {
      paymentService
        .getPaymentSession(this.$auth.token())
        .then((result) => {
          window.location.href = result;
        })
        .catch((err) => {});
    },
    checkoutPayment() {
      paymentService
        .getPaymentCheckout(this.$auth.token())
        .then((result) => {
          window.location.href = result;
        })
        .catch((err) => {});
    },
    getBills() {
      var client = this.clientView;
      paymentService
        .getPaymentBillingMonth(this.$auth.token(), client)
        .then((bills) => {
          this.billingitems = bills._embedded;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getDataMonth() {
      if (this.$auth.getMyUser().roles.indexOf("admin") > -1) {
        userService
          .getClient(this.$auth.token(), this.clientView)
          .then((client) => {
            this.isContractReady =
              client.isContractReady !== undefined
                ? client.isContractReady
                : false;
            this.isContractSigned =
              client.isContractSigned !== undefined
                ? client.isContractSigned
                : false;
            this.isRIB = client.isRIB !== undefined ? client.isRIB : false;
            this.typeOfContract =
              client.typeOfContract !== undefined
                ? client.typeOfContract
                : "views";

            this.maxData =
              client.maxData !== undefined ? client.maxData : this.baseData;

            this.multiplierData =
              client.multiplierData !== undefined
                ? client.multiplierData
                : this.multiplierData;

            this.priceData =
              client.priceData !== undefined
                ? client.priceData
                : this.priceData;

            this.baseData =
              client.baseData !== undefined ? client.baseData : this.maxData;

            this.clientType = client.type;

            this.basePrice =
              client.price || client.freeOver
                ? this.basePrice
                : this.basePrice2;

            this.demoOver = (client.demoOver) ? true : false;

            if (this.clientView === 'digiteka') {
              this.currentPrice = this.computeNewPriceDigi(this.currentDataTB);
            }
            else if (this.clientView === 'digiteka') {
              this.currentPrice = this.computeNewPriceSportall(this.currentDataTB);
            }
            else {
              this.currentPrice = this.computeNewPrice(this.currentDataTB);
            }
            this.isLoaded = true;
          });
      } else {
        userService.getMyUser(this.$auth.token()).then((user) => {
          this.isContractReady =
            user.client_infos[0].isContractReady !== undefined
              ? user.client_infos[0].isContractReady
              : false;
          this.isContractSigned =
            user.client_infos[0].isContractSigned !== undefined
              ? user.client_infos[0].isContractSigned
              : false;
          this.isRIB =
            user.client_infos[0].isRIB !== undefined
              ? user.client_infos[0].isRIB
              : false;
          this.typeOfContract =
            user.client_infos[0].typeOfContract !== undefined
              ? user.client_infos[0].typeOfContract
              : "views";

          this.maxData =
            user.client_infos[0].maxData !== undefined
              ? user.client_infos[0].maxData
              : this.baseData;

          this.multiplierData =
            user.client_infos[0].multiplierData !== undefined
              ? user.client_infos[0].multiplierData
              : this.multiplierData;

          this.priceData =
            user.client_infos[0].priceData !== undefined
              ? user.client_infos[0].priceData
              : this.priceData;

          this.baseData =
            user.client_infos[0].baseData !== undefined
              ? user.client_infos[0].baseData
              : this.maxData;

          this.clientType = user.client_infos[0].type;

          this.basePrice =
            user.client_infos[0].price || user.client_infos[0].freeOver
              ? this.basePrice
              : this.basePrice2;

          this.demoOver = (user.client_infos[0].demoOver) ? true : false;

          if (this.clientView === 'digiteka') {
            this.currentPrice = this.computeNewPriceDigi(this.currentDataTB);
          }
          else if (this.clientView === 'sportall') {
            this.currentPrice = this.computeNewPriceSportall(this.currentDataTB);
          }
          else {
            this.currentPrice = this.computeNewPrice(this.currentDataTB);
          }
          this.isLoaded = true;
        });
      }
    },
    setAutoAdjust() {
      this.isAutoAdjust = true;

      while (this.currentData > this.maxData) {
        this.maxData += this.multiplierData;
      }
    },
    increaseData() {
      this.maxData = this.maxData + this.multiplierData;
    },
    /*
    computeNewPrice() {
      let bonusData = Math.floor(this.maxData / this.multiplierData);
      bonusData--;
      if (bonusData < 0) {
        bonusData = 0;
      }
      return this.basePrice + this.priceData * bonusData;
    },
    */

    computeNewPrice(dataTB) {
      if (dataTB < 50) {
        this.currentPricePerTB = 5;
      }
      else
        if (dataTB < 100) {
          this.currentPricePerTB = 6 - (dataTB/50);
        }
        else
          if (dataTB < 200) {
            this.currentPricePerTB = 5 - (dataTB/100);
          }
          else
            if (dataTB < 400) {
              this.currentPricePerTB = 4 - (dataTB/200);
            }
            else
              if (dataTB < 800) {
                this.currentPricePerTB = 5/2 - (dataTB/800);
              }
              else
                if (dataTB < 1600) {
                  this.currentPricePerTB = 2 - (dataTB/1600);
                }
                else
                  if (dataTB >= 1600) {
                    this.currentPricePerTB = 1;
                  }
      
      this.currentPriceTotal = Math.ceil(dataTB) * this.currentPricePerTB;

      this.currentPricePerTB = this.currentPricePerTB.toFixed(2); 
      this.currentPriceTotal = this.currentPriceTotal.toFixed(2); 

      return this.currentPriceTotal;
    },
    computeNewPriceDigi(dataTB) {
      if (dataTB < 750) {
        this.currentPricePerTB = 1.35;
      }
      else
        if (dataTB < 1200) {
          this.currentPricePerTB = 29/15 - (7*dataTB/9000);
        }
        else
          if (dataTB >= 1200) {
            this.currentPricePerTB = 1;
          }
      
      this.currentPriceTotal = Math.ceil(dataTB) * this.currentPricePerTB;

      this.currentPricePerTB = this.currentPricePerTB.toFixed(2); 
      this.currentPriceTotal = this.currentPriceTotal.toFixed(2); 

      return this.currentPriceTotal;
    },
    computeNewPriceSportall(dataTB) {
      if (dataTB < 100) {
        this.currentPricePerTB = 4;
      }
      else
        if (dataTB < 200) {
          this.currentPricePerTB = 5 - (dataTB/100);
        }
        else
          if (dataTB < 400) {
            this.currentPricePerTB = 4 - (dataTB/200);
          }
          else
            if (dataTB < 800) {
              this.currentPricePerTB = 5/2 - (dataTB/800);
            }
            else
              if (dataTB < 1600) {
                this.currentPricePerTB = 2 - (dataTB/1600);
              }
              else
                if (dataTB >= 1600) {
                  this.currentPricePerTB = 1;
                }
      
      this.currentPriceTotal = Math.ceil(dataTB) * this.currentPricePerTB;

      this.currentPricePerTB = this.currentPricePerTB.toFixed(2); 
      this.currentPriceTotal = this.currentPriceTotal.toFixed(2); 

      return this.currentPriceTotal;
    },


    //Show modal if wrong date
    showModal(ref) {
      this.$refs[ref].show();
    },
    hideModal(ref) {
      this.$refs[ref].hide();
    },
    loadNewClientUuid() {
      let self = this;
      return new Promise((done, reject) => {
        let values = [{ name: "new_client_uuid.keyword", type: "cardinality" }];
        let options = {
          dateBegin: self.dateBegin,
          dateEnd: self.dateEnd,
          interval: self.interval,
          filter: self.filter,
        };
        let data = self.templateRequest(options, values);
        self
          .loadRequest(data, values)
          .then(() => {
            self.totalViews = self.new_client_uuid.reduce((a, b) => {
              return { y: Math.round(a.y + b.y) };
            }).y;
            done();
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    downloadDocuments(filename) {
      documentService
        .downloadDocuments(this.$auth.token(), filename)
        .then((data) => {
          saveAs(data, filename);
        })
        .catch((err) => {
          console.log(err);
        });
    },
    loadData() {
      let self = this;
      return new Promise((done, reject) => {
        let values = [{ name: "MB_peer", type: "sum" }];
        let options = {
          dateBegin: self.dateBegin,
          dateEnd: self.dateEnd,
          interval: self.interval,
          filter: self.filter,
        };
        let data = self.templateRequest(options, values);
        self
          .loadRequest(data, values)
          .then(() => {
            let totalMB_peer = self.MB_peer.reduce((a, b) => {
              return { y: Math.round(a.y + b.y) };
            }).y;
            cdnService
              .getCDNsData(self.$auth.token())
              .then((data) => {
                let dataCDN = data.bytes || 0;
                self.totalData = totalMB_peer + dataCDN / 1000;
                self.currentData = Math.round(self.totalData / 1000000);
                self.currentDataTB = self.currentData / 1000;
                self.setAutoAdjust();
                done();
              })
              .catch((err) => {
                self.totalData = totalMB_peer;
                self.currentData = Math.round(self.totalData / 1000000);
                self.currentDataTB = self.currentData / 1000;
                self.setAutoAdjust();
                done();
              });
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    loadData_LastMonth() {
      let self = this;
      return new Promise((done, reject) => {
        let values = [{ name: "MB_peer", type: "sum" }];
        let options = {
          dateBegin: self.dateBeginLastMonth,
          dateEnd: self.dateEndLastMonth,
          interval: self.interval,
          filter: self.filter,
        };
        let data = self.templateRequest(options, values);
        self
          .loadRequest(data, values)
          .then(() => {
            let totalMB_peer = self.MB_peer.reduce((a, b) => {
              return { y: Math.round(a.y + b.y) };
            }).y;
            self.lastData = Math.round(totalMB_peer/ 1000000);
            self.lastDataTB = self.lastData / 1000;

            if (this.clientView === 'digiteka') {
              this.lastPrice = this.computeNewPriceDigi(this.lastDataTB);
            }
            else 
              if (this.clientView === 'sportall') {
                this.lastPrice = this.computeNewPriceSportall(this.lastDataTB);
              }
              else {
                this.lastPrice = this.computeNewPrice(this.lastDataTB);
              }

          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    loadRequest(data, valuesToFill) {
      let self = this;
      return new Promise((done, reject) => {
        analyticsService
          .getAnalyticsFromServer(self.key, data, self.$auth.token())
          .then((response) => {
            let buckets = response.aggregations.histogram.buckets;
            for (let j = 0; j < valuesToFill.length; j++) {
              let myValue =
                valuesToFill[j].name.indexOf("keyword") > -1
                  ? valuesToFill[j].name.split(".")[0]
                  : valuesToFill[j].name;
              self[myValue] = [];
            }
            for (let i = 0; i < buckets.length; i++) {
              for (let j = 0; j < valuesToFill.length; j++) {
                let myValue =
                  valuesToFill[j].name.indexOf("keyword") > -1
                    ? valuesToFill[j].name.split(".")[0]
                    : valuesToFill[j].name;
                self[myValue].push({
                  x: new Date(buckets[i].key),
                  y: buckets[i][myValue].value,
                });
              }
            }
            done();
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    templateRequest({ dateBegin, dateEnd, interval, filter }, values) {
      let data = {
        query: {
          bool: {
            filter: [
              {
                range: {
                  timestamp: {
                    gte: dateBegin.getTime().toString(),
                    lte: dateEnd.getTime().toString(),
                    format: "epoch_millis",
                  },
                },
              },
              {
                query_string: {
                  analyze_wildcard: true,
                  query: filter,
                },
              },
            ],
          },
        },
        size: 0,
        aggs: {
          histogram: {
            date_histogram: {
              interval: interval,
              field: "timestamp",
              min_doc_count: 0,
              extended_bounds: {
                min: dateBegin.getTime().toString(),
                max: dateEnd.getTime().toString(),
              },
              format: "epoch_millis",
            },
            aggs: {},
          },
        },
      };

      for (var i = 0; i < values.length; i++) {
        let name =
          values[i].name.indexOf("keyword") > -1
            ? values[i].name.split(".")[0]
            : values[i].name;
        let value = values[i].name;
        let type = values[i].type;
        data.aggs.histogram.aggs[name] = {};
        data.aggs.histogram.aggs[name][type] = {
          field: value,
          missing: 0,
        };
      }

      return data;
    },
    validateContract() {
      this.isContractSigned = true;
      try {
        clientService
          .putClientContract(
            this.clientView,
            this.isContractSigned,
            this.$auth.token()
          )
          .then(() => {
            this.isContractSigned = true;
            this.paymentdetails = false;
            this.showModal("ContractAccepted");
            this.$auth.validateWithServer();
          })
          .catch((err) => {
            this.isContractSigned = false;
            this.showModal("ErrorContract");
          });
      } catch (err) {
        this.isContractSigned = false;
        this.showModal("ErrorContract");
      }
    },
    postRIB() {
      let monthTable = [
        "january",
        "february",
        "march",
        "april",
        "may",
        "june",
        "july",
        "august",
        "september",
        "october",
        "november",
        "december",
      ];
      let formData = new FormData();
      formData.append("client", this.clientView);
      formData.append("type", "rib");
      formData.append("year", new Date().getFullYear());
      formData.append("month", monthTable[new Date().getMonth()]);
      formData.append(
        "file",
        this.file,
        "RIB_" + new Date().getTime() + ".pdf"
      );

      documentService
        .postDocument(this.$auth.token(), formData)
        .then(() => {
          this.file = null;
          this.isRIB = true;
          clientService
            .putClientRIB(this.clientView, this.isRIB, this.$auth.token())
            .then(() => {
              this.isRIB = true;
              this.paymentdetails = false;
              this.showModal("RIBSuccess");
              this.$auth.validateWithServer();
            })
            .catch((err) => {
              this.isRIB = false;
              this.showModal("RIBError");
            });
        })
        .catch((err) => {
          this.showModal("RIBError");
        });
    },
  },
};
</script>

<style scoped>
@media print {
  .noprint {
    display: none;
  }
}

input:invalid {
    border: 3px solid red;
}

datalist {
  display: flex;
  justify-content: space-between;
  width: 300px;
  font-size: 10px;
}

option {
  padding: 0;
}

input[type="range"] {
  width: 300px;
  margin: 0;
}
</style>